import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import "./barchart.scss";
import { Icons } from "../Icons";
import { addCommas } from "../../helpers/helpers";

const BarChart = ({
  data,
  drawDown,
  savings,
  showLine,
  mobile,
  selectedIndex,
}) => {
  const [percentages, setPercentages] = useState([]);
  const { savingPots, drawdownPots, dbPension } = data;
  // prettier-ignore
  const textRef = Array.from(
    { length: savingPots?.savings.length },
    () => useRef()
  );

  const textValueRef = Array.from(
    { length: savingPots?.savings.length },
    () => useRef() //eslint-disable-line
  );

  const drawdownTextRef = Array.from(
    { length: drawdownPots?.drawdown.length },
    () => useRef() //eslint-disable-line
  );

  const drawdownValueRef = Array.from(
    { length: drawdownPots?.drawdown.length },
    () => useRef() //eslint-disable-line
  );

  var savingDecimalValue = ((savingPots && savingPots.totalSavingsValue) % 1)
    .toFixed(2)
    .substring(2);
  var drawdownDecimalValue = (
    (drawdownPots && drawdownPots.totalDrawdownValue) % 1
  )
    .toFixed(2)
    .substring(2);

  // const maxValue = Math.max(...data.map((item) => item.value));
  // const sum = data.reduce((acc, currentValue) => acc + currentValue.value, 0);

  useEffect(() => {
    // const values = [10, 5, 4, 1, 6, 8, 20, 30, 40, 50];

    let percentages = [];

    let savingsData = savingPots?.savings || [];
    let drawdown = drawdownPots?.drawdown || [];

    let totalPotValue = [...savingsData, ...drawdown];

    // prettier-ignore
    percentages = mobile
      ? Array(totalPotValue.length).fill(
          parseFloat((100 / totalPotValue.length).toFixed(2))
        )
      : savings
        ? Array(savingPots?.savings.length).fill(
            parseFloat((100 / savingPots?.savings.length).toFixed(2))
          )
        : drawDown
          ? Array(drawdownPots?.drawdown.length).fill(
              parseFloat((100 / drawdownPots?.drawdown.length).toFixed(2))
            )
          : "";

    const hasPercentageBelowFive = (percentages) => {
      for (const percentage of percentages) {
        if (percentage < 10.4) {
          return true;
        }
      }
      return false;
    };

    const countPercentagesBelowFive = (percentages) => {
      let count = 0;
      for (const percentage of percentages) {
        if (percentage <= 10.4) {
          count++;
        }
      }
      return count;
    };

    do {
      let remainingPercentage = 0;
      if (savings) {
        for (let i = 0; i < savingPots?.savings.length; i++) {
          if (percentages[i] < 10.4) {
            remainingPercentage += 10.4 - percentages[i];
            percentages[i] = 10.4;
          }
        }

        const deductionPerPercentage =
          remainingPercentage /
          (savingPots?.savings.length - countPercentagesBelowFive(percentages));

        for (let i = 0; i < savingPots?.savings.length; i++) {
          if (percentages[i] > 10.4) {
            percentages[i] -= deductionPerPercentage;
          }
        }
      } else if (drawDown) {
        for (let i = 0; i < drawdownPots?.drawdown.length; i++) {
          if (percentages[i] < 10.4) {
            remainingPercentage += 10.4 - percentages[i];
            percentages[i] = 10.4;
          }
        }

        const deductionPerPercentage =
          remainingPercentage /
          (drawdownPots?.drawdown.length -
            countPercentagesBelowFive(percentages));

        for (let i = 0; i < drawdownPots?.drawdown.length; i++) {
          if (percentages[i] > 10.4) {
            percentages[i] -= deductionPerPercentage;
          }
        }
      } else {
        for (let i = 0; i < totalPotValue.length; i++) {
          if (percentages[i] < 10.4) {
            remainingPercentage += 10.4 - percentages[i];
            percentages[i] = 10.4;
          }
        }

        const deductionPerPercentage =
          remainingPercentage /
          (totalPotValue.length - countPercentagesBelowFive(percentages));

        for (let i = 0; i < totalPotValue.length; i++) {
          if (percentages[i] > 10.4) {
            percentages[i] -= deductionPerPercentage;
          }
        }
      }
    } while (hasPercentageBelowFive(percentages));
    if (percentages.length === 1 || percentages[0] <= 10.4) {
      percentages[0] = 100;
    }
    setPercentages(percentages);
  }, []);

  return (
    <div>
      {drawDown ? (
        showLine ? (
          <>
            <div className="parent-hr">Drawdown</div>
            <hr className="drawdown-line" />
          </>
        ) : (
          ""
        )
      ) : showLine ? (
        <>
          <div className="parent-hr">Savings</div>
          <hr className="savings-line" />
        </>
      ) : (
        ""
      )}
      <Row
        className={
          mobile && savingPots?.savings.length >= 1 && dbPension
            ? "barchart-height-width"
            : mobile && savingPots?.savings.length > 1
              ? "barchart-height"
              : mobile &&
                  savingPots?.savings.length >= 1 &&
                  drawdownPots?.drawdown.length >= 1
                ? "barchart-height"
                : mobile &&
                    savingPots?.savings.length === 0 &&
                    drawdownPots?.drawdown.length >= 1
                  ? "barchart-height"
                  : ""
        }
      >
        {mobile ? (
          <Col className="container">
            {savingPots?.savings.length >= 1 && dbPension === true
              ? savingPots.savings.map((item, index) => (
                  <>
                    <Card
                      key={index}
                      style={{
                        width: `${percentages[index] - 0.4}%`,
                        marginRight: "1px",
                        borderRadius: `${
                          savingPots?.savings.length === 1
                            ? "8px"
                            : `${
                                index === 0
                                  ? "8px 0 0 8px"
                                  : index === savingPots?.savings.length - 1
                                    ? "0 8px 8px 0"
                                    : "0"
                              }`
                        }`,
                        bottom: "20px",
                      }}
                      className="mobile-card-chart"
                    >
                      {" "}
                      {index === selectedIndex && (
                        <Col
                          style={{
                            alignItems: "center",
                            position: "absolute",
                            transition: "1s",
                            bottom: "-20px",
                          }}
                        >
                          <div>
                            <div>
                              <Icons
                                iconname="indicator"
                                variant="icon-thirtytwo-fifteen-px"
                              />
                            </div>
                          </div>
                        </Col>
                      )}
                    </Card>
                    {index === savingPots?.savings.length - 1 ? (
                      <>
                        <div className="dbpension-plus-icon">
                          <Icons
                            iconname="plus"
                            variant="icon-sixteen-px icon-plus-align"
                          />
                        </div>
                        <Card className="db-card-chart">
                          <p className="p-text">DB</p>
                          {index + 1 === selectedIndex && (
                            <Col
                              style={{
                                alignItems: "center",
                                position: "absolute",
                                transition: "1s",
                                bottom: "-20px",
                              }}
                            >
                              <div>
                                <div>
                                  <Icons
                                    iconname="indicator"
                                    variant="icon-thirtytwo-fifteen-px"
                                  />
                                </div>
                              </div>
                            </Col>
                          )}
                        </Card>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))
              : percentages.map((item, index) => (
                  <Card
                    key={index}
                    style={{
                      width: `${percentages[index] - 0.4}%`,
                      borderRadius: `${
                        percentages.length === 1
                          ? "8px"
                          : index === 0
                            ? "8px 0 0 8px"
                            : index === percentages.length - 1
                              ? "0 8px 8px 0"
                              : "0"
                      }`,
                      bottom: "20px",
                    }}
                    className={
                      index >= savingPots?.savings.length
                        ? "mobile-drawdown-card-chart"
                        : "mobile-card-chart"
                    }
                  >
                    {" "}
                    {index === selectedIndex && (
                      <Col
                        style={{
                          alignItems: "center",
                          position: "absolute",
                          transition: "1s",
                          bottom: "-20px",
                        }}
                      >
                        <div>
                          <div>
                            <Icons
                              iconname="indicator"
                              variant="icon-thirtytwo-fifteen-px"
                            />
                          </div>
                        </div>
                      </Col>
                    )}
                  </Card>
                ))}
          </Col>
        ) : (
          <Col
            className={
              dbPension ? "barchart-db-container" : "barchart-container"
            }
          >
            {savings === true &&
              savingPots.savings.map((item, index) => (
                <Card
                  key={index}
                  style={{
                    width: `${percentages[index] - 0.4}%`,
                    borderRadius: `${
                      savingPots?.savings.length === 1
                        ? "8px"
                        : index === 0
                          ? "8px 0 0 8px"
                          : index === savingPots?.savings.length - 1
                            ? "0 8px 8px 0"
                            : "0"
                    }`,
                  }}
                  className={"savings-card-chart"}
                >
                  {item.status === "Active" ? (
                    percentages[index] > 10.4 ? (
                      <div className="active-div">
                        <div className="active-text">ACTIVE</div>
                      </div>
                    ) : (
                      <div className="active-div-small-empty">
                        <div className="active-text">ACTIVE</div>
                      </div>
                    )
                  ) : (
                    <div className="inactive-text"></div>
                  )}
                  <div
                    className="p-text"
                    style={{
                      width: "100%",
                    }}
                  >
                    {percentages[index] - 0.4 >= 10 && mobile !== true ? (
                      <>
                        <div className="cyber-text">
                          <div>
                            {percentages[index] - 0.4 > 10 ? (
                              item.employerId
                            ) : (
                              <div className="id-empty-div"></div>
                            )}
                          </div>
                          <div className="pot-name" ref={textRef[index]}>
                            {percentages[index] - 0.4 > 10 ? (
                              item.employerName
                            ) : (
                              <div className="name-empty-div"></div>
                            )}
                          </div>
                        </div>
                        <div className="pot-value" ref={textValueRef[index]}>
                          {percentages[index] - 0.4 > 10 ? (
                            `£${addCommas(Math.trunc(item.totalBalance))}.`
                          ) : (
                            <div className="value-empty-div"></div>
                          )}
                          {percentages[index] - 0.4 > 10 ? (
                            <span className="chart-small-digit">
                              {(item.totalBalance % 1).toFixed(2).substring(2)}
                            </span>
                          ) : (
                            <div className="value-empty-div"></div>
                          )}
                        </div>
                        <div>{percentages[index] - 0.4 <= 10 ? "" : ""}</div>
                        {(textRef[index].current &&
                          textRef[index].current.scrollWidth >
                            textRef[index].current.clientWidth) ||
                        (textValueRef[index].current &&
                          textValueRef[index].current.scrollWidth >
                            textValueRef[index].current.clientWidth) ? (
                          <Icons variant="icon-sixteen-px" />
                        ) : (
                          <Icons variant="icon-sixteen-px" />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Card>
                //   </Col>
              ))}
            {drawDown === true &&
              drawdownPots.drawdown.map((item, index) => (
                <Card
                  key={index}
                  style={{
                    width: `${percentages[index] - 0.4}%`,
                    borderRadius: `${
                      drawdownPots?.drawdown.length === 1
                        ? "8px"
                        : index === 0
                          ? "8px 0 0 8px"
                          : index === drawdownPots?.drawdown.length - 1
                            ? "0 8px 8px 0"
                            : "0"
                    }`,
                  }}
                  className={"drawdown-card-chart"}
                >
                  <div
                    className="p-text"
                    style={{
                      width: "100%",
                    }}
                  >
                    {percentages[index] - 0.4 >= 10 && mobile !== true ? (
                      <>
                        <div className="cyber-text pt-3">
                          <div>
                            {percentages[index] - 0.4 > 10 ? (
                              item.employerId
                            ) : (
                              <div className="id-empty-div"></div>
                            )}
                          </div>
                          <div
                            className="pot-name"
                            ref={drawdownTextRef[index]}
                          >
                            {percentages[index] - 0.4 > 10 ? (
                              item.employerName
                            ) : (
                              <div className="empty-div"></div>
                            )}
                          </div>
                        </div>
                        <div
                          className="pot-value"
                          ref={drawdownValueRef[index]}
                        >
                          {percentages[index] - 0.4 > 10
                            ? `£${addCommas(Math.trunc(item.totalBalance))}.`
                            : ""}
                          {percentages[index] - 0.4 > 10 ? (
                            <span className="chart-small-digit">
                              {(item.totalBalance % 1).toFixed(2).substring(2)}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>{percentages[index] - 0.4 <= 10 ? "" : ""}</div>
                        {(drawdownTextRef[index].current &&
                          drawdownTextRef[index].current.scrollWidth >
                            drawdownTextRef[index].current.clientWidth) ||
                        (drawdownValueRef[index].current &&
                          drawdownValueRef[index].current.scrollWidth >
                            drawdownValueRef[index].current.clientWidth) ? (
                          <Icons variant="icon-sixteen-px" />
                        ) : (
                          <Icons variant="icon-sixteen-px" />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Card>
                //   </Col>
              ))}
          </Col>
        )}
      </Row>
      {(mobile && savingPots?.savings.length > 1) ||
      (mobile && savingPots?.savings.length >= 1 && dbPension) ||
      (mobile &&
        savingPots?.savings.length >= 1 &&
        drawdownPots?.drawdown.length >= 1) ||
      (mobile &&
        savingPots?.savings.length === 0 &&
        drawdownPots?.drawdown.length >= 1) ? (
        ""
      ) : mobile && savingPots?.savings.length === 1 ? (
        ""
      ) : savings ? (
        <div className="indicator-align">
          <div>
            <div style={{ textAlign: "right" }}>
              <Icons iconname="indicator" variant="icon-thirtytwo-fifteen-px" />
            </div>
            <div className="total-value-text">Total value</div>
            <div className="total-value">
              £
              {addCommas(
                Math.trunc(
                  savingPots && savingPots.totalSavingsValue //eslint-disable-line
                ).toString() //eslint-disable-line
              )}
              .<span className="small-digit">{savingDecimalValue}</span>
            </div>
          </div>
        </div>
      ) : drawDown ? (
        <div className="indicator-align">
          <div>
            <div style={{ textAlign: "right" }}>
              <Icons iconname="indicator" variant="icon-thirtytwo-fifteen-px" />
            </div>
            <div className="total-value-text">Total value</div>
            <div className="total-value">
              £
              {addCommas(
                Math.trunc(
                  drawdownPots && drawdownPots.totalDrawdownValue //eslint-disable-line
                ).toString() //eslint-disable-line
              )}
              .<span className="small-digit">{drawdownDecimalValue}</span>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BarChart;
